import ModuleSetupPage from '../../components/ModuleSetupPage';
import { CombinedConfigPage } from '../admin/ConfigPage';

export default function DispatchSetupPage() {
  return (
    <ModuleSetupPage
      moduleKey="dispatch"
      moduleLabel="Dispatch"
      configComponent={<CombinedConfigPage />}
    />
  );
}
